import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=7fe1ce39&scoped=true"
import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=7fe1ce39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1ce39",
  null
  
)

export default component.exports